import React from 'react';

const ZeroInvitationImage: React.FC<{}> = () => (
  <svg width="122" height="125" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M117.253 85.387l-79.685 26.326a3.744 3.744 0 01-4.729-2.379L13.505 50.811a3.742 3.742 0 012.38-4.728L95.57 19.757a3.746 3.746 0 014.731 2.38l19.333 58.52a3.743 3.743 0 01-2.381 4.73z"
      fill="#E5E9F8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M96.746 17.76c-.591 0-1.178.095-1.742.28L15.32 44.366a5.556 5.556 0 00-3.53 7.012L31.125 109.9a5.542 5.542 0 005.27 3.809 5.53 5.53 0 001.741-.28l79.685-26.328a5.51 5.51 0 003.217-2.774 5.515 5.515 0 00.311-4.236L102.015 21.57a5.542 5.542 0 00-5.27-3.81zm0 1.805c1.57 0 3.034.997 3.554 2.571l19.334 58.522a3.743 3.743 0 01-2.381 4.73l-79.685 26.326a3.746 3.746 0 01-4.73-2.381L13.506 50.811a3.745 3.745 0 012.38-4.73L95.57 19.755c.391-.128.787-.19 1.176-.19z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.732 112.665a5.171 5.171 0 01-4.918-3.557l-1.305-3.947 16.277-34.267 23.06 12.276c.478.255.992.384 1.529.384a3.279 3.279 0 002.95-1.864l11.21-23.598 33.485 17.827 1.304 3.948a5.188 5.188 0 01-3.295 6.544l-78.67 25.991a5.168 5.168 0 01-1.627.263z"
      fill="#E5E9F8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.124 56.852l-.811 1.706L73.51 81.302a2.378 2.378 0 01-2.137 1.35c-.386 0-.758-.095-1.105-.28l-22.226-11.83-1.667-.889-.812 1.708-13.51 28.442-2.205 4.643-.31.654.228.686 1.189 3.605a6.076 6.076 0 007.687 3.869l78.669-25.99a6.093 6.093 0 003.869-7.686l-1.191-3.606-.227-.687-.639-.34-4.536-2.415-27.796-14.797-1.668-.887zm.82 2.482l27.794 14.795 4.538 2.415 1.191 3.605a4.28 4.28 0 01-2.721 5.406l-78.67 25.99a4.28 4.28 0 01-5.405-2.72l-1.19-3.605 2.205-4.643 13.51-28.443 22.226 11.832a4.136 4.136 0 001.952.491 4.166 4.166 0 003.766-2.38l10.804-22.743z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.57 83.435a8.613 8.613 0 01-4.03-1.01l-51.62-27.48-1.104-3.343a5.14 5.14 0 01.29-3.955 5.145 5.145 0 013.004-2.59l78.669-25.992a5.208 5.208 0 011.626-.261 5.171 5.171 0 014.92 3.557l1.105 3.342-25.09 52.824a8.64 8.64 0 01-7.77 4.908z"
      fill="#E5E9F8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M96.405 17.9c-.648 0-1.29.104-1.909.309l-78.668 25.99a6.033 6.033 0 00-3.527 3.042 6.036 6.036 0 00-.343 4.644l.99 3 .227.687.64.34 51.301 27.31a9.51 9.51 0 004.455 1.116 9.543 9.543 0 008.584-5.424l24.935-52.496.311-.655-.227-.686-.991-3a6.075 6.075 0 00-5.778-4.178zm0 1.805c1.796 0 3.47 1.14 4.063 2.938l.99 3.001L76.524 78.14a7.69 7.69 0 01-10.56 3.488l-51.3-27.31-.99-2.999a4.277 4.277 0 012.718-5.406l78.671-25.99a4.284 4.284 0 011.342-.218z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M81.152 65.707C78.545 57.814 69.21 53.66 61.49 56.739c-8.388 3.343-11.77 11.156-9.163 19.047a14.986 14.986 0 006.438 8.11l-.002.003.055.027a15.147 15.147 0 004.661 1.845c2.09.69 3.33.668 5.084.5 3.916-.376 3.837 3.305 7.823 2.054 4.353-1.366 3.004-5.451 3.973-8.403.969-2.951 1.379-6.513 1.298-8.512 0-.012-.008-.023-.01-.036.034-1.664.057-3.998-.495-5.667z"
      fill="#F0F2FB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M79.345 73.63c.048-.197.054-.339.042-.46.276-1.874.141-3.837-.493-5.76-2.181-6.6-9.3-10.184-15.901-8.002-6.6 2.18-10.185 9.298-8.002 15.9 1.99 6.027 8.1 9.525 14.174 8.427.743-.048 1.481-.105 1.94-.172 1.213-.175 1.184.322 2.89-.579 2.093-1.102 2.004-2.244 3.092-3.584.89-1.097 1.469-2.762 1.949-4.56.02-.067.036-.133.054-.2.087-.334.173-.671.255-1.01z"
      fill="#D5DAF2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.761 67.786c-4.703-4.188-8.08 1.373-5.503 5.243 1.958 2.946 6.198 4.657 8.114 5.307.588.2 1.224-.01 1.577-.52 1.153-1.666 3.538-5.566 3.357-9.098-.238-4.642-6.262-7.098-7.545-.932z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.4 108.152a1.803 1.803 0 002.278 1.147l53.177-17.57-53.612 13.096a2.588 2.588 0 00-1.844 3.327z"
      fill="#D5DAF2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.524 82.81c1.283-1.327 2.584-2.606 3.882-3.897l-.71-2.716c-12.64 12.52-16.34 21.884-16.34 21.884 3.577-4.827 7.797-9.717 13.168-15.27zM20.608 88.28c.065-.066.13-.129.194-.196l-.708-2.706c-.404.413-.814.812-1.216 1.228-2.607 2.697-4.97 5.185-7.026 7.656C2.65 105.32.662 114.623.662 114.623c1.3-2.599 2.73-4.935 4.075-7.004 4.018-6.179 8.914-12.143 15.871-19.34zM22.449 94.387c-2.797 2.97-5.224 5.728-7.381 8.398-8.734 10.934-10.018 21.88-10.018 21.88.068-.251.125-.5.207-.753 1.428-4.509 3.776-8.431 5.882-11.671 3.16-4.859 6.957-9.626 12.031-15.098l-.721-2.756z"
      fill="#E5E9F8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.525 15.527l5.71-.744-5.71-.743a4.306 4.306 0 01-3.73-3.887L38.91.204l-.886 9.949a4.304 4.304 0 01-3.73 3.886l-5.71.744 5.71.744c2.001.26 3.552 1.877 3.73 3.886l.886 9.948.883-9.948a4.304 4.304 0 013.73-3.886zm71.433-1.15l4.27-.556-4.27-.558a3.22 3.22 0 01-2.791-2.905l-.66-7.442-.662 7.442a3.218 3.218 0 01-2.789 2.905l-4.271.558 4.271.556a3.218 3.218 0 012.789 2.905l.662 7.442.66-7.442a3.22 3.22 0 012.791-2.905zM14.633 29.553a1.491 1.491 0 11-2.982.001 1.491 1.491 0 012.982 0zm39.229-5.675a1.49 1.49 0 100-2.981 1.49 1.49 0 000 2.98z"
      fill="#B0BDE8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.567 8.494a6.546 6.546 0 003.449 3.557.69.69 0 01-.02 1.272 6.536 6.536 0 00-3.555 3.45.69.69 0 01-1.273-.021 6.54 6.54 0 00-3.448-3.556.69.69 0 01.02-1.271 6.542 6.542 0 003.555-3.45.69.69 0 011.272.02zm51.587 17.816a1.491 1.491 0 11-2.982 0 1.491 1.491 0 012.982 0zM8.196 41.405a4.88 4.88 0 01-2.608-2.609.513.513 0 00-.946 0 4.88 4.88 0 01-2.609 2.608.514.514 0 000 .948 4.874 4.874 0 012.609 2.607c.178.42.768.42.946 0a4.874 4.874 0 012.608-2.607c.42-.18.42-.77 0-.947z"
      fill="#E5E9F8"
    />
  </svg>
);

export default ZeroInvitationImage;
